import React from 'react';
import {useParams} from "wouter";
import {swrFetcher} from "@/utils/api.ts";
import {FiHeart, FiMessageCircle, FiSend} from "react-icons/fi";
import BackButton from "../../components/BackButton.tsx";
import ViewInPlatform from "../../components/ui/ViewInPlatform.tsx";
import {AssetResponseItem, GenericAsset, TweetAsset} from "@/@types/AssetTypes.ts";
import useSWRImmutable from "swr/immutable";
import RenderPostType from "../../components/ui/RenderPostType.tsx";
import Spinner from "@/components/spinner.tsx";
import FormattedNumber from "@/components/FormattedNumber.tsx";
import PostPreview from "@/pages/posts/PostPreview.tsx";

function ViewPublishedPost(){
    const {id} = useParams<{ id: string }>();

    const {data, isLoading} = useSWRImmutable<AssetResponseItem>(`/assets/${id}?include=metrics`, swrFetcher);

    return <>
        <BackButton />
        <h3 className={"text-2xl mb-1"}>{data?.title || <RenderPostType type={data?.type} />}</h3>
        <ViewPublishedPostInternal data={data} isLoading={isLoading} />
    </>
}

function ViewPublishedPostInternal({data, isLoading}:{
    data: AssetResponseItem,
    isLoading: boolean
}) {

    if (isLoading) {
        return <Spinner />
    }

    if (!data) {
        return <div className="text-center mt-4">Post not found</div>;
    }
    const platform = data?.account.platform;
    const metrics = data.metrics;
    return <div className={"grid grid-cols-2"}>
        <div>
            <PostPreview type={data?.type} post={(data.data as GenericAsset | TweetAsset).post}
                         metrics={data?.metrics}
                         post_at={data?.post_at} account={data?.account}/>
        </div>
        <div className={"card"}>
            <div className="card-body">
                <div className="
                grid grid-cols-1 md:grid-cols-3 gap-2">
                    <StatsCard
                        Icon={FiHeart}
                        value={metrics?.likes || 0} title={"Likes"}/>
                    <StatsCard
                        Icon={FiMessageCircle}
                        value={metrics?.comments || 0} title={"Comments"}/>
                    <StatsCard
                        Icon={FiSend}
                        value={metrics?.shares || 0} title={"Shares"}/>
                </div>
                <div className="mt-4">
                    <ViewInPlatform
                        metadata={data.metadata} type={data.type}/>
                </div>
            </div>
        </div>
    </div>
}

function StatsCard({value, title, Icon}) {
    return <div className={"card bg-base-200 p-4"}>
            <h3 className={"text-2xl mb-2"}><FormattedNumber value={value} /></h3>
            <small className={"flex items-center gap-2"}><Icon size={18}/> {title}</small>
    </div>
}

// function InstagramPostViewGridView({post}) {
//     const {account, assets, caption} = post;
//     const likes = 0;
//     const comments = [];
//     return <div className="card mb-4">
//         <div className="row">
//             <div className="col-md-7">
//
//             </div>
//         </div>
//         <div className="card-header d-flex align-items-center">
//             <img src={account.picture?.url} alt={account.name} className="rounded-circle"
//                  style={{width: 32, height: 32}}/>
//             <div className="ms-2">
//                 <span className="fw-bold">{account.name || account.username}</span>
//             </div>
//         </div>
//         <div className="card-body p-0">
//             {assets.map((asset, index) => (
//                 <img key={index} src={asset.url} alt="Post asset" className="img-fluid w-100"/>
//             ))}
//             <div className="p-3">
//                 <div className="d-flex justify-content-between mb-2">
//                     <div className="d-flex gap-3">
//                         <FiHeart size={24}/>
//                         <FiMessageCircle size={24}/>
//                         <FiSend size={24}/>
//                     </div>
//                     <FiBookmark size={24}/>
//                 </div>
//                 <div>
//                     <span className="fw-bold">{likes} likes</span>
//                 </div>
//                 <div className="mt-2">
//                     <span className="fw-bold">{account.username}</span> {caption}
//                 </div>
//                 <div className="mt-2">
//                     {comments.map((comment, index) => (
//                         <div key={index} className="d-flex align-items-start mb-2">
//                             <span className="fw-bold me-2">{comment.username}</span>
//                             <span>{comment.text}</span>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     </div>
// }

export default ViewPublishedPost;
